import { render, staticRenderFns } from "./edit-coins.vue?vue&type=template&id=c156af30"
import script from "./edit-coins.vue?vue&type=script&lang=js"
export * from "./edit-coins.vue?vue&type=script&lang=js"
import style0 from "./edit-coins.vue?vue&type=style&index=0&id=c156af30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports